"use client"
import { useEffect } from 'react';

/** when state is true - blocks body scroll */
function useNoScroll(blockState: boolean) {
    useEffect(() => {
        if (blockState) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [blockState]);
}

export default useNoScroll